// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__6fxoq","bigColWidth":"Table_bigColWidth__167JK","biggerColWidth":"Table_biggerColWidth__33Xqc","row":"Table_row__34Fbz","col":"Table_col__2t8XI"};